var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHollowStarSmall = function SvgHollowStarSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#C2C4CC",
    d: "M9.14 1.046a.95.95 0 0 1 1.72 0l1.967 4.015c.286.583.837.992 1.479 1.085l4.364.639c.783.115 1.124 1.123.528 1.708l-3.13 3.073a2.02 2.02 0 0 0-.571 1.776l.743 4.361c.142.835-.703 1.423-1.39 1.06l-3.942-2.089a1.94 1.94 0 0 0-1.816 0L5.15 18.762c-.686.364-1.53-.224-1.389-1.059l.743-4.36a2.02 2.02 0 0 0-.57-1.777L.801 8.493C.206 7.908.547 6.9 1.33 6.785l4.363-.639a1.97 1.97 0 0 0 1.479-1.085z"
  })));
};
export default SvgHollowStarSmall;